import axios from 'axios';
import Notification from '../notification/notification-es';

// Initialize notification popup
const popup = Notification({
    position: 'top-right',
    duration: 3000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

const classPrefix = 'modal-support';
const dataPrefix = 'data-modal-support';

// Select the modal container
const $modal = document.querySelector(`[${dataPrefix}]`);

if ($modal) {
    initModalOpen();
    setupModalSupport($modal);

}

// Generic listener: opens support modal when any button with data-modal-open="support" is clicked
function initModalOpen() {
    document.addEventListener('click', event => {
        const button = event.target.closest('[data-modal-open="support"]');
        if (!button || !$modal) return;

        // Read specialist ID directly from button attribute
        const specialistId = button.getAttribute('data-specialist-id') || '0';

        // Inject ID into modal and reset state
        $modal.setAttribute(dataPrefix, specialistId);
        const textarea = $modal.querySelector(`[${dataPrefix}-message]`);
        textarea.value = '';
        textarea.classList.remove('is-invalid');

        // Open modal
        $modal.classList.add(`${classPrefix}--open`);

        axios.post('/api/specialist/support-event', {
            specialist_id: specialistId,
            event: 'open'
        });
    });
}



/**
 * Sets up the support modal: element references, event listeners, and state
 * @param {HTMLElement} container - The modal container element
 */
export function setupModalSupport(container) {
    const $textarea = container.querySelector(`[${dataPrefix}-message]`);
    const $button = container.querySelector(`[${dataPrefix}-button]`);
    const $modalContainer = container.querySelector(`.${classPrefix}__container`);
    const $modalCloseBtn = container.querySelector(`.${classPrefix}__container-close`);

    $modalCloseBtn.addEventListener('click', () => {
        container.classList.remove(`${classPrefix}--open`);
    });

    // Закрытие по клику вне модального контейнера
    container.addEventListener('click', (event) => {
        if (!event.target.closest(`.${classPrefix}__container`)) {
            container.classList.remove(`${classPrefix}--open`);
        }
    });


    // Предотвращаем всплытие при клике по контейнеру
    $modalContainer.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    // Обработка отправки формы
    $button.addEventListener('click', onSubmit);

    async function onSubmit() {
        const message = $textarea.value.trim();
        $textarea.classList.remove('is-invalid');

        if (!message) {
            return showValidationError('Пожалуйста, введите сообщение.');
        }
        if (message.length < 10) {
            return showValidationError('Сообщение слишком короткое. Минимум 10 символов.');
        }

        $button.setAttribute('disabled', '');
        $button.textContent = 'Отправка...';

        try {
            const specialistId = container.getAttribute(dataPrefix);
            await axios.post('/api/specialist/support', {
                specialist_id: specialistId,
                message,
            });

            popup.success({ message: 'Ваш запрос успешно отправлен!' });
            container.classList.remove(`${classPrefix}--open`);
        } catch (err) {
            console.error(err);
            const text = err.response?.data?.error || 'Произошла ошибка. Попробуйте позже.';
            popup.error({ message: text });
        } finally {
            $button.removeAttribute('disabled');
            $button.textContent = 'Отправить';
        }
    }

    function showValidationError(message) {
        $textarea.classList.add('is-invalid');
        popup.error({ message });
    }
}
